import React from 'react';
import { toast } from 'sonner';

const PortCallSettings = ({ formData, handleChange }) => {
  return (
    <div style={{ padding: '2rem' }}>
      <h3 style={{ marginBottom: '1.5rem', color: '#059669' }}>
        ⚓ Liman Çağrısı Tipleri
      </h3>
      <p style={{ color: '#64748b', marginBottom: '1.5rem' }}>
        Proforma oluştururken seçilebilecek liman çağrısı tiplerini yönetin. Bu tipler hizmet kalemlerinin otomatik eklenmesini kontrol eder.
      </p>
      
      {/* Yeni Tip Ekleme */}
      <div style={{ 
        background: '#f0fdf4', 
        padding: '1rem', 
        borderRadius: '8px',
        marginBottom: '1.5rem',
        border: '1px solid #86efac'
      }}>
        <h4 style={{ fontSize: '1rem', fontWeight: 600, marginBottom: '1rem', color: '#16a34a' }}>
          Yeni Liman Çağrısı Tipi Ekle
        </h4>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr auto', gap: '1rem', alignItems: 'flex-end' }}>
          <div>
            <label style={{ fontSize: '0.75rem', fontWeight: 600, color: '#64748b', marginBottom: '0.25rem', display: 'block' }}>Türkçe Ad</label>
            <input
              type="text"
              className="form-input"
              placeholder="Örn: Yakıt İkmali"
              id="new_portcall_name_tr"
            />
          </div>
          <div>
            <label style={{ fontSize: '0.75rem', fontWeight: 600, color: '#64748b', marginBottom: '0.25rem', display: 'block' }}>İngilizce Ad</label>
            <input
              type="text"
              className="form-input"
              placeholder="Örn: Bunkering"
              id="new_portcall_name_en"
            />
          </div>
          <button
            type="button"
            onClick={() => {
              const nameTr = document.getElementById('new_portcall_name_tr').value.trim();
              const nameEn = document.getElementById('new_portcall_name_en').value.trim();
              if (nameTr && nameEn) {
                const newType = {
                  id: nameTr.toLowerCase().replace(/\s+/g, '_'),
                  name_tr: nameTr,
                  name_en: nameEn,
                  active: true
                };
                handleChange('port_call_types', [...(formData.port_call_types || []), newType]);
                document.getElementById('new_portcall_name_tr').value = '';
                document.getElementById('new_portcall_name_en').value = '';
                toast.success('Liman çağrısı tipi eklendi');
              }
            }}
            style={{
              padding: '0.6rem 1.5rem',
              background: '#16a34a',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontWeight: 600,
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}
          >
            + Ekle
          </button>
        </div>
      </div>

      {/* Mevcut Tipler Listesi */}
      <div style={{ border: '1px solid #e2e8f0', borderRadius: '8px', overflow: 'hidden' }}>
        <div style={{ 
          background: '#f8fafc', 
          padding: '0.75rem 1rem', 
          fontWeight: 600, 
          fontSize: '0.9rem',
          borderBottom: '1px solid #e2e8f0',
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 80px 60px',
          gap: '1rem'
        }}>
          <span>Türkçe Ad</span>
          <span>İngilizce Ad</span>
          <span style={{ textAlign: 'center' }}>Aktif</span>
          <span style={{ textAlign: 'center' }}>Sil</span>
        </div>
        {(formData.port_call_types || []).map((type, index) => (
          <div key={index} style={{ 
            padding: '0.75rem 1rem', 
            borderBottom: index < (formData.port_call_types || []).length - 1 ? '1px solid #e2e8f0' : 'none',
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 80px 60px',
            gap: '1rem',
            alignItems: 'center',
            background: index % 2 === 0 ? '#fff' : '#f9fafb'
          }}>
            <input
              type="text"
              className="form-input"
              value={type.name_tr}
              onChange={(e) => {
                const updated = [...(formData.port_call_types || [])];
                updated[index].name_tr = e.target.value;
                handleChange('port_call_types', updated);
              }}
              style={{ margin: 0 }}
            />
            <input
              type="text"
              className="form-input"
              value={type.name_en}
              onChange={(e) => {
                const updated = [...(formData.port_call_types || [])];
                updated[index].name_en = e.target.value;
                handleChange('port_call_types', updated);
              }}
              style={{ margin: 0 }}
            />
            <div style={{ textAlign: 'center' }}>
              <input
                type="checkbox"
                checked={type.active !== false}
                onChange={(e) => {
                  const updated = [...(formData.port_call_types || [])];
                  updated[index].active = e.target.checked;
                  handleChange('port_call_types', updated);
                }}
                style={{ width: '18px', height: '18px', accentColor: '#10b981' }}
              />
            </div>
            <div style={{ textAlign: 'center' }}>
              <button
                type="button"
                onClick={() => {
                  if (window.confirm(`"${type.name_tr}" tipini silmek istediğinize emin misiniz?`)) {
                    const updated = (formData.port_call_types || []).filter((_, i) => i !== index);
                    handleChange('port_call_types', updated);
                    toast.success('Liman çağrısı tipi silindi');
                  }
                }}
                style={{
                  padding: '0.25rem 0.5rem',
                  background: '#ef4444',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '0.75rem'
                }}
              >
                ✗
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Operational Checklist Bölümü */}
      <div style={{ marginTop: '3rem', paddingTop: '2rem', borderTop: '2px solid #e2e8f0' }}>
        <h3 style={{ marginBottom: '1.5rem', color: '#059669', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          ✓ Operasyonel Kontrol Listesi
        </h3>
        <p style={{ color: '#64748b', marginBottom: '1.5rem' }}>
          Yeni liman çağrısı oluşturulduğunda varsayılan olarak eklenecek kontrol listesi öğelerini yönetin.
        </p>
        
        {/* Yeni Madde Ekleme */}
        <div style={{ 
          background: '#f0fdf4', 
          padding: '1rem', 
          borderRadius: '8px',
          marginBottom: '1.5rem',
          border: '1px solid #86efac'
        }}>
          <h4 style={{ fontSize: '1rem', fontWeight: 600, marginBottom: '1rem', color: '#16a34a' }}>
            Yeni Madde Ekle
          </h4>
          <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-end' }}>
            <div style={{ flex: 1 }}>
              <label style={{ fontSize: '0.75rem', fontWeight: 600, color: '#64748b', marginBottom: '0.25rem', display: 'block' }}>Görev Adı</label>
              <input
                type="text"
                className="form-input"
                placeholder="Örn: Port authority notification"
                id="new_checklist_item"
              />
            </div>
            <button
              type="button"
              onClick={() => {
                const itemText = document.getElementById('new_checklist_item').value.trim();
                if (itemText) {
                  const currentItems = formData.operational_checklist_items || [];
                  handleChange('operational_checklist_items', [...currentItems, itemText]);
                  document.getElementById('new_checklist_item').value = '';
                  toast.success('Kontrol listesi maddesi eklendi');
                }
              }}
              style={{
                padding: '0.6rem 1.5rem',
                background: '#16a34a',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontWeight: 600,
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
              }}
            >
              + Ekle
            </button>
          </div>
        </div>

        {/* Mevcut Maddeler */}
        <div style={{ border: '1px solid #e2e8f0', borderRadius: '8px', overflow: 'hidden' }}>
          <div style={{ 
            background: '#f8fafc', 
            padding: '0.75rem 1rem', 
            fontWeight: 600, 
            fontSize: '0.9rem',
            borderBottom: '1px solid #e2e8f0',
            display: 'grid',
            gridTemplateColumns: '40px 1fr 60px',
            gap: '1rem'
          }}>
            <span>Sıra</span>
            <span>Görev</span>
            <span style={{ textAlign: 'center' }}>Sil</span>
          </div>
          {(formData.operational_checklist_items || []).map((item, index) => (
            <div key={index} style={{ 
              padding: '0.75rem 1rem', 
              borderBottom: index < (formData.operational_checklist_items || []).length - 1 ? '1px solid #e2e8f0' : 'none',
              display: 'grid',
              gridTemplateColumns: '40px 1fr 60px',
              gap: '1rem',
              alignItems: 'center',
              background: index % 2 === 0 ? '#fff' : '#f9fafb'
            }}>
              <span style={{ 
                width: '28px', 
                height: '28px', 
                background: '#e2e8f0', 
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 600,
                fontSize: '0.85rem',
                color: '#64748b'
              }}>
                {index + 1}
              </span>
              <input
                type="text"
                className="form-input"
                value={item}
                onChange={(e) => {
                  const updated = [...(formData.operational_checklist_items || [])];
                  updated[index] = e.target.value;
                  handleChange('operational_checklist_items', updated);
                }}
                style={{ margin: 0 }}
              />
              <div style={{ textAlign: 'center' }}>
                <button
                  type="button"
                  onClick={() => {
                    if (window.confirm(`Bu maddeyi silmek istediğinize emin misiniz?`)) {
                      const updated = (formData.operational_checklist_items || []).filter((_, i) => i !== index);
                      handleChange('operational_checklist_items', updated);
                      toast.success('Madde silindi');
                    }
                  }}
                  style={{
                    padding: '0.25rem 0.5rem',
                    background: '#ef4444',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '0.75rem'
                  }}
                >
                  ✗
                </button>
              </div>
            </div>
          ))}
          {(!formData.operational_checklist_items || formData.operational_checklist_items.length === 0) && (
            <div style={{ padding: '2rem', textAlign: 'center', color: '#9ca3af' }}>
              Henüz kontrol listesi maddesi eklenmedi
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PortCallSettings;
